import { AzureSuggestsResult } from "../../azure-search/models/azure-suggests-result.model";

export type SearchTarget = "rentals" | "sale" | "attachments" | "parts";
export function commerceSearchIntent(
  term: string
): { target: SearchTarget; query: string } | null {
  const value = (term || "").trim();
  const parts = /\b(parts?|accessories|replacement)\b/i.test(value);
  if (!parts && !/\battachments?\b/i.test(value)) return null;
  return {
    target: parts ? "parts" : "attachments",
    query: value
      .replace(/\b(attachments?|parts?|accessories|replacement)\b/gi, " ")
      .replace(/\b(for|compatible with)\b/gi, " ").replace(/\s+/g, " ")
      .trim(),
  };
}
export function searchDestination(
  target: SearchTarget,
  query: string,
  equipmentParams: any = {}
): { path: string; queryParams: any } {
  if (target === "attachments" || target === "parts")
    return {
      path:
        target === "parts" ? "/shop/attachments/parts-accessories" : "/shop/attachments",
      queryParams: { q: query || null },
    };
  const params = {
    ...equipmentParams,
    q: query || null,
    buyItNowEnabled: target === "sale" ? "true" : null,
    rpoEnabled: null,
  };
  return {
    path:
      target === "sale" ? "/equipment-for-sale/all" : "/equipment-rentals/all",
    queryParams: params,
  };
}
export function searchScopeSuggestions(term: string): AzureSuggestsResult[] {
  const query = commerceSearchIntent(term)?.query ?? (term || "").trim();
  if (!query || query.length < 2) return [];
  return (
    [
      ["rentals", "Equipment for rent"],
      ["sale", "Equipment for sale"],
      ["attachments", "Shop attachments"],
      ["parts", "Parts & accessories"],
    ] as [SearchTarget, string][]
  ).map(([target, label]) => {
    const result = new AzureSuggestsResult(
      `${label}: ${query
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")}`,
      `${label}: ${query}`,
      [],
      []
    );
    result.searchTarget = target;
    result.searchQuery = query;
    return result;
  });
}
